export default function LoadingPanel (){
    return (<></>)
}